export const ROUTES = {
  ROOT: "/",
  DASHBOARD: "/dashboard",
  CHAT: "/chat",
  NOTES: "/notes",
  // MISSIONS: "/missions",
  CURRENT_AFFAIRS: "/currentaffairs",
  SYLLABUS: "/syllabus",
  PLANNER: "/planner",
  TESTS: "/tests",
  HISTORY: "/history",
  PROFILE: "/profile",
  BILLING: "/billing",
  REFERRALS: "/referrals",
  LOGIN: "/login",
  LOGIN_EMAIL: "/loginemail",
  SIGNUP: "/signup",
  ADMIN_PROMPTS: "/adminprompts",
  ADMIN: "/admin",
  ADMIN_TESTS_BUILDER: "/admin/tests/builder",
  ADMIN_TESTS_MANAGEMENT: "/admin/tests/management",
  ADMIN_QUESTIONS_BANK: "/admin/questions/bank",
  ADMIN_QUESTIONS_REPORTS: "/admin/questions/reports",
  ADMIN_USERS: "/admin/users",
  ADMIN_MENTORS_ASSIGNMENT: "/admin/mentors/assignment",
  ADMIN_MENTORS_NOTIFICATIONS: "/admin/mentors/notifications",
  ADMIN_MENTORS_REPORTS: "/admin/mentors/reports",
  ADMIN_ANALYTICS_USERS: "/admin/analytics/users",
  ADMIN_ANALYTICS_TESTS: "/admin/analytics/tests",
  ADMIN_ANALYTICS_PAYMENTS: "/admin/analytics/payments",
  ADMIN_SYSTEM_USERS: "/admin/system/users",
  ADMIN_SYSTEM_ROLES: "/admin/system/roles",
  ADMIN_SYSTEM_AUDIT: "/admin/system/audit-logs",
};
